import React from 'react'

import ArticleParagraphMolecule  from '@/molecules/Paragraphs/ArticleParagraph'

const ArticleParagraph = (props) => (
  <ArticleParagraphMolecule {...props} />
)

export default ArticleParagraph
